//业务单位信息目录
import request from '@/utils/httpRequest'

export function queryById(id) {
    return request({
        url: '/base/wuyeBaseCorpInfo/queryById',
        method: 'get',
        params: {id: id}
    })
}

export function startFlow(params) {
    return request({
        url: '/base/wuyeBaseCorpInfo/startFlow',
        method: 'post',
        data: params
    })
}